import { useEffect } from 'react'
import { useNotificationService } from '@hapana/shared/web/services/notification.service'
import useSiteStore from '_stores/site.store'

const FCM_TYPES_SHOWN_OUTSIDE_TOASTS = new Set(['EQUIPMENT_STATUS_UPDATED', 'CHECK_IN_CREATED'])

export const useServiceWorkerMessages = () => {
  const { showNotification } = useNotificationService()

  useEffect(() => {
    const channel = new BroadcastChannel('fcm-notifications')

    const messageHandler = (event) => {
      if (event.data?.type !== 'FCM_NOTIFICATION') {
        return
      }
      const fcmData = event.data.data?.data
      if (FCM_TYPES_SHOWN_OUTSIDE_TOASTS.has(fcmData?.type)) {
        return
      }

      // Site-scoped notifications must only surface for the
      // location the user currently has selected. FCM topic subscriptions are
      // eventually-consistent and a shared device can linger on a previous site's
      // topic, so gate on siteId here rather than trusting the subscription alone.
      if (fcmData?.siteId) {
        const currentSiteId = useSiteStore.getState().currentSite?.siteId
        if (fcmData.siteId !== currentSiteId) {
          return
        }
      }

      showNotification(event.data.data)
    }

    channel.addEventListener('message', messageHandler)

    return () => {
      channel.removeEventListener('message', messageHandler)
      channel.close()
    }
  }, [])
}
